/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:02 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var Config = require("manager-assets/config/config.json");

    var KEYS = {
        NAME:      "name",
        ORDER:     "order",
        PROPOSED:  "proposed",
        DELETED:   "deleted",
        ASSIGNED_CAMPAIGNS: "assignedCampaigns",
        ASSIGNED_CONTENT: "assignedContent"
    };

    var CategoryModel = RevisionedModel.extend({
        KEYS:KEYS,
        MAX_NAME_LENGTH: Config.validators.categories.maxNameLength,
        resource: ApiResources.AccountConfig.Categories,
        name: "CategoryModel",
        defaults: {
            id: null, //new model id must be null so model.isNew() wil work
            name: "",
            deleted: false,
            proposed:true,
            assignedContent: 0,
            assignedCampaigns: 0
        },

        initialize: function (options) {
            RevisionedModel.prototype.initialize.call(this, options);
        },

        validation: {
            name: [
                {
                    required: true,
                    minLength: 1,
                    msg: "LEManager.categories.errors.categoryName.required"
                },
                {
                    maxLength: Config.validators.categories.maxNameLength,
                    msg: "LEManager.categories.errors.categoryName.length"
                }
            ]
        },

        /**
         * Category model is a special creature.
         * When the model is part of collection, we need to handle its deletion from the collection because it needs to update the other models' ORDER attribute.
         * @param options
         */
        destroy: function(options) {
            if (this.collection) {
                this.collection.destroyModels([this.id], options);
            }
            else {
                RevisionedModel.prototype.destroy.call(this, options);
            }
        },

        /**
         * Override the getRevision method.
         * This is a specific override because the edit of category is done from the list and we dont fetch its model before editing.
         * If a category name is modified - the revision of the model is modified as well.
         * If a category is deleted - the revision of the collection is modified, so when the user comes to edit its name the revision should be get from the collection.
         * @returns {*}
         */
        getRevision: function(all) {
            var collectionRevision = this.getCollectionRevision(all);
            var modelRevisionValue = this.lpRevision && this.lpRevision.val ? parseInt(this.lpRevision.val, 10) : 0;
            var collectionRevisionValue = all && collectionRevision && collectionRevision.val ? parseInt(collectionRevision.val, 10) : collectionRevision;

            if (all) {
                return modelRevisionValue === _.max([modelRevisionValue, collectionRevisionValue]) ? this.lpRevision : collectionRevision;
            }
            else {
                return _.max([modelRevisionValue, collectionRevisionValue]).toString();
            }
        },

        getLastModified: function() {
            var collectionLastModified = this.getCollectionLastModified() || 0;
            var modelLastModified = this.lpRevision && this.lpRevision.lastModified ? parseInt(this.lpRevision.lastModified, 10) : 0;
            var max = _.max([modelLastModified, collectionLastModified]);

            return max ? max.toString() : void 0;
        },

        getName: function () {
            return this.get(KEYS.NAME);
        },
        getOrder: function () {
            return this.get(KEYS.ORDER);
        },
        getProposed: function () {
            return this.get(KEYS.PROPOSED);
        },
        getAssignedContent: function () {
            return this.get(KEYS.ASSIGNED_CONTENT);
        },
        getAssignedCampaigns: function () {
            return this.get(KEYS.ASSIGNED_CAMPAIGNS);
        }

    });

    CategoryModel.KEYS = KEYS;
    return CategoryModel;
});
